import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';

const LoadPPLive = Loadable({
    loader: () => import('./ppLive'),
    loading() {
        return <div />;
    },
});

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        leftRef: PropTypes.any,
        rightRef: PropTypes.any,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { floatAd5, ppxAd },
            leftRef,
            rightRef,
        } = this.props;

        const affix = (
            <React.Fragment>
                <div ref={leftRef} />
                <div ref={rightRef} />
                <Ad content={floatAd5} styleName={styles.floatAd} />
                {ppxAd && ppxAd.length > 0 ? <LoadPPLive tag="page_ppposiiton_live7" content={ppxAd} /> : ''}
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
